import { render } from "./MultipleSelector.vue?vue&type=template&id=f19b1036&scoped=true"
import script from "./MultipleSelector.vue?vue&type=script&lang=js"
export * from "./MultipleSelector.vue?vue&type=script&lang=js"

import "./MultipleSelector.vue?vue&type=style&index=0&id=f19b1036&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f19b1036"]])

export default __exports__